<template>
    <div class="card">
        <div class="card-header">
            Clientes
        </div>

        <div class="card-body">
            <div class="text-center">
                <h2>{{clients.count}} </h2>

                <ul class="text-left list-unstyled" style="font-size: 0.9rem;" >
                    <li>{{clients.mSex}} Clientes masculinos</li>
                    <li>{{clients.fSex}} Clientes femininos</li>
                    <li>{{clients.sex}} Sexo não cadastrado</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'vwClients',
    data(){
        return {
            clients: {
                count: 0,
                mSex    : 0,
                fSex    : 0,
                sex     : 0
            }
        }
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    methods: {
        getData: function(){
            fetch(server + 'gethomeclientsinfo?token='+this.getToken, {
                method: 'GET',
            })
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.data

                    let count = 0
                    let mSex  = 0
                    let fSex  = 0
                    let sex   = 0

                    if(data.length > 0){
                        data.forEach(element => {
                            count = parseInt(count) + parseInt(element.TOTAL)

                            if(element.SEXO == 'FEMININO'){
                                fSex = element.TOTAL
                            }else if(element.SEXO == 'MASCULINO'){
                                mSex = element.TOTAL
                            }else{
                                sex = element.TOTAL
                            }
                        });

                        this.clients.count  = count
                        this.clients.fSex   = fSex
                        this.clients.mSex   = mSex
                        this.clients.sex    = sex
                    }
                })
                .catch(error => {
                    console.log('Error', '=>', error)
                })
        }
    },
    mounted(){
        this.getData()
    }
}
</script>